export default __webpack_public_path__ + "b31a89ce5555412a0c8a4c6463286584.svg";